export default "assets/images/icons/arrow-white-circle-blue-ee0195c9.svg";